module.exports = __webpack_public_path__ + "static/BT-mobile-18-77406594890973bcc121b3e13cd064b4.jpg";